import { render, staticRenderFns } from "./paper-bgcheck.vue?vue&type=template&id=76479642&scoped=true"
import script from "./paper-bgcheck.vue?vue&type=script&lang=ts"
export * from "./paper-bgcheck.vue?vue&type=script&lang=ts"
import style0 from "./paper-bgcheck.vue?vue&type=style&index=0&id=76479642&prod&lang=scss&scoped=true"
import style1 from "./paper-bgcheck.vue?vue&type=style&index=1&id=76479642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76479642",
  null
  
)

export default component.exports